import '@aofl/select';
import '@aofl/drawer';

export default (ctx, html) => html`
  <form id="payment-form-container" name="payment-form" @submit="${(e) => ctx.submitForm(e)}" novalidate>
    <fieldset class="cc-card-payment">
      <div class="input-container ${ctx.form.cardName.valid ? '' : 'is-invalid'}">
        <label class="cc-input-label" for="card-name">Cardholder<span class="u-br"></span> Name</label>
        <div class="input-wrapper">
          <input id="card-name" type="text" @blur="${(e) => ctx.validateCardName(e)}" @input="${(e) => ctx.updateCardName(e)}" value="${ctx.cardName}" autocomplete="cc-name">
          ${ctx.form.cardName.valid ? '' : html`
            <label class="error-message" for="card-name">Please enter a valid cardholder name.</label>
          `}
        </div>
      </div>
      <div class="input-container ${ctx.form.cardNumber.valid ? '' : 'is-invalid'}">
        <label class="cc-input-label" for="cc-num">Credit Card<span class="u-br"></span> Number</label>
        <div class="input-wrapper">
          <input id="cc-num" type="tel" @blur="${(e) => ctx.validateCardNumber(e)}" @input="${(e) => ctx.updateCardNumber(e)}" value="${ctx.cardNumber}" autocomplete="cc-number">
          ${ctx.form.cardNumber.isRequired.valid ? '' : html`
            <label class="error-message" for="cc-num">Please enter the card number.</label>
          `}
          ${ctx.form.cardNumber.isNotZero.valid ? '' : html`
            <label class="error-message" for="cc-num">Your card number is invalid.</label>
          `}
        </div>
      </div>
      <div class="input-container ${(ctx.form.expDate.valid && ctx.form.cardCvv.valid) ? '' : 'is-invalid'}">
        <label>Expiration<span class="u-br"></span> Date</label>
        <div id="dropdown-row">
          <div id="date-selector" class="${ctx.form.expDate.valid}">
            <div class="mkt-dropdown" id="billing-info-month">
              <div class="dropdown-wrapper">
                <aofl-drawer animate-drawer="false" ?open="${ctx.monthDropdownActive}">
                  <aofl-select-list @change="${(e) => ctx.updateCardMonth(e)}">
                  ${ctx.months.map((month) => html`
                    <aofl-list-option value=${month}>${month}</aofl-list-option>
                  `)}
                </aofl-select-list>
                </aofl-drawer>
                <div class="button-wrapper" @click="${(e) => ctx.toggleMonth(e)}">
                  <div class="display-box">
                    <span>${ctx.cardMonth}</span>
                  </div>
                  <div class="dropdown-arrow">
                    <span>&#9662;</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="mkt-dropdown" id="billing-info-year">
              <div class="dropdown-wrapper">
                <aofl-drawer animate-drawer="false" ?open="${ctx.yearDropdownActive}">
                  <aofl-select-list @change="${(e) => ctx.updateCardYear(e)}">
                  ${ctx.years.map((year) => html`
                    <aofl-list-option value=${year}>${year}</aofl-list-option>
                  `)}
                </aofl-select-list>
                </aofl-drawer>
                <div class="button-wrapper" @click="${(e) => ctx.toggleYear(e)}">
                  <div class="display-box">
                    <span>${ctx.cardYear}</span>
                  </div>
                  <div class="dropdown-arrow">
                    <span>&#9662;</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          ${ctx.form.expDate.isNotExpired.valid ? '' : html`
            <label class="error-message" for="exp-date">Your expiration date is invalid.</label>
          `}
          <div id="cvv-wrapper" class="input-container">
            <div id="cvv-error-wrapper">
              <div class="error-wrapper ${ctx.form.cardCvv.valid ? '' : 'is-invalid'}">
                <input id="cvv" type="tel" maxlength="4" @input="${(e) => ctx.updateCardCvv(e)}" value="${ctx.cardCvv}" @blur="${(e) => ctx.validateCardCvv(e)}" placeholder="CVV">
                ${ctx.form.cardCvv.isRequired.valid ? '' : html`
                <label class="error-message ${ctx.form.cardCvv.isRequired.valid}" for="ccv">Please enter card security code.</label>
                `}
                ${ctx.form.cardCvv.isNotEmoji.valid && ctx.form.cardCvv.isNotZero.valid ? '' : html`
                <label class="error-message ${ctx.form.cardCvv.isRequired.valid}" for="ccv">Your card security code is invalid.</label>
                `}
              </div>
              <button id="cvv-button" dom-scope="UJLWkMQg" class="button blue" type="button" tabindex="-1" @click="${(e) => ctx.showCvvPopup(e)}">?</button>
            </div>
          </div>
        </div>
      </div>
      <div id="zip-code-input-container" class="input-container ${ctx.form.zipCode.valid ? '' : 'is-invalid'}">
        <label class="cc-input-label" for="zipcode">Billing Zip/<span class="u-br"></span>Postal Code</label>
        <div class="input-wrapper">
          <input id="zipcode" type="tel" @blur="${(e) => ctx.validateZipCode(e)}" @input="${(e) => ctx.updateZipCode(e)}" placeholder="Gift/International cards: enter 12345" value="${ctx.zipCode}" autocomplete="postal-code">
          ${ctx.form.zipCode.isRequired.valid ? '' : html`
            <label class="error-message" for="zipcode">Please provide Zip or Postal Code.</label>
          `}
          ${ctx.form.zipCode.isNotZero.valid && ctx.form.zipCode.isNotEmoji.valid ? '' : html`
          <label class="error-message" for="zipcode">Zip or Postal Code format you entered is invalid.</label>
          `}
        </div>
      </div>
      <div class="input-container">
        <label class="cc-input-label" for="phone-number">Phone<span class="u-br"></span> Number</label>
        <div class="input-wrapper">
          <input id="phone-number" type="tel" @input="${(e) => ctx.updatePhoneNumber(e)}" placeholder="Optional, but recommended" value="${ctx.phoneNumber}" autocomplete="tel">
        </div>
      </div>
    </fieldset>
    <button id="payment-submit-button" dom-scope="ZF7TRMDr" type="submit" tabindex="-1"></button>
  </form>
`;
